import { render } from "./BtnPlus.vue?vue&type=template&id=0d590026"
const script = {}

import "./BtnPlus.vue?vue&type=style&index=0&id=0d590026&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__